module.exports = __webpack_public_path__ + "assets/img/loginIcon2.5f6712da.png";